import { render, staticRenderFns } from "./product-group-proList.vue?vue&type=template&id=3edf7499&scoped=true&"
import script from "./product-group-proList.vue?vue&type=script&lang=js&"
export * from "./product-group-proList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf7499",
  null
  
)

export default component.exports